import React, { Component } from 'react';
import {
    Button,
    Menu,
    MenuItem,
    Toolbar
} from '@material-ui/core';
import PersonIcon from 'react-icons/lib/md/person';
import UserStorage from '../utility/UserStorage';
import { Link } from 'react-router-dom'
import { LoginService } from 'common';
import { palette } from '../themes/petroff.theme';
import WebHttpService from '../services/WebHttpService'
import clientConfig from '../clientConfig';



const loginService = new LoginService(WebHttpService,UserStorage,clientConfig)

const styles = {
    username: {
        color: palette.common.white
    }
}

class NavLinks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
        }
    }

    openSignoutMenu(e) {
        this.setState({
            menuOpen: true,
            anchorEl:e.currentTarget
        })
    }

    render() {
        
        const loggedInUserName = UserStorage.getLoggedInUser();
        return (<Toolbar>
            <div className='sign-out-container'>
                <Button
                    style={styles.username}
                    className='user-name'    
                    onClick={(e) => this.openSignoutMenu(e)}><PersonIcon /> {loggedInUserName}</Button>        
                    <Menu 
                        width={150}
                        open={this.state.menuOpen}
                        anchorEl={this.state.anchorEl}
                        onClose={() => this.setState({ menuOpen: false })}>
                        <MenuItem className='profile-item' onClick={() => this.setState({ menuOpen: false})}                        
                        ><Link to='/profile'>Profile</Link></MenuItem>                            
                        <MenuItem className='sign-out'  onClick={ async () => {
                            await loginService.logout(loggedInUserName);
                            this.props.setIsAuthenticated(false);
                        }}><Link to="/login">Sign out</Link></MenuItem>
                    </Menu>
            </div>
        </Toolbar>);      
    }
};

export default NavLinks;
